"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sensor = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const Sensor = ({ onClickOutside, onEscape, children }) => {
    const ref = (0, react_1.useRef)(null);
    const handleClickEvent = (0, react_1.useCallback)((e) => {
        if (!(ref === null || ref === void 0 ? void 0 : ref.current))
            return;
        if (e instanceof MouseEvent &&
            e.target instanceof Element &&
            !ref.current.contains(e.target)) {
            onClickOutside(e);
        }
    }, [onClickOutside]);
    const handleKeyboardEvent = (0, react_1.useCallback)((e) => {
        if (!(ref === null || ref === void 0 ? void 0 : ref.current))
            return;
        if (e instanceof KeyboardEvent && e.key === 'Escape') {
            onEscape();
        }
    }, [onEscape]);
    (0, react_1.useEffect)(() => {
        document.addEventListener('mousedown', handleClickEvent, true);
        document.addEventListener('keydown', handleKeyboardEvent, true);
        return () => {
            document.removeEventListener('mousedown', handleClickEvent, true);
            document.removeEventListener('keydown', handleKeyboardEvent, true);
        };
    }, [handleKeyboardEvent, handleClickEvent]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: { display: 'inline-block' }, ref: ref }, { children: children })));
};
exports.Sensor = Sensor;
//# sourceMappingURL=sensor.js.map